import React from 'react'
import cx from 'classnames'
import { TableModuleProps } from './interfaces/TableModule'

export type { TableModuleProps } from './interfaces/TableModule'

export const TableModule = ({ data }: { data: TableModuleProps }) => {
  const {
    title,
    disclaimer,
    backgroundColor,
    headerBackgroundColor = 'bctran',
    headerContentTone = 'dark',
    subHeaderBackgroundColor = 'bctran',
    subHeaderContentTone = 'dark',
    cellBackgroundColor = 'bctran',
    cellContentTone = 'dark',
    spacing,
    subTable,
    table,
    deepLinkId,
  } = data
  const rows = [...(subTable?.rows || []), ...(table?.rows || [])]
  const maxColumnCount = Math.max(1, ...rows.map(row => row.cells?.length || 0))
  const minTableWidth = `${maxColumnCount * 180}px`
  const headerToneClass = headerContentTone === 'light' ? 'cw' : 'cb'
  const subHeaderToneClass = subHeaderContentTone === 'light' ? 'cw' : 'cb'
  const cellToneClass = cellContentTone === 'light' ? 'cw' : 'cb'

  const getRowStyle = (cellCount = 1): React.CSSProperties => {
    const columnCount = Math.max(1, cellCount)

    return {
      gridTemplateColumns: `repeat(${columnCount}, minmax(180px, 1fr))`,
      minWidth: minTableWidth,
    }
  }

  return (
    <div
      id={deepLinkId}
      className={cx(backgroundColor, {
        cw: backgroundColor === 'bcb',
      })}
    >
      <div className={cx('container--l mxa outer p1', spacing)}>
        <div className="x ba br table__legacy">
          {title && (
            <h3
              className={cx(
                'p1 m0 x table__header',
                headerBackgroundColor,
                headerToneClass
              )}
              style={{ minWidth: minTableWidth }}
            >
              {title}
            </h3>
          )}
          {subTable?.rows?.map(row => (
            <div
              key={row._key}
              className={cx(
                'table__row no-bars',
                subHeaderBackgroundColor,
                subHeaderToneClass,
                {
                  table__3: row.cells?.length === 3,
                }
              )}
              style={getRowStyle(row.cells?.length)}
            >
              {row.cells?.map((cell, i) => (
                <div
                  key={i}
                  className="h4 basis bold"
                  dangerouslySetInnerHTML={{ __html: cell }}
                />
              ))}
            </div>
          ))}
          {table?.rows?.map(row => (
            <div
              key={row._key}
              className={cx(
                'table__row',
                cellBackgroundColor,
                cellToneClass,
                {
                  table__3: row.cells?.length === 3,
                }
              )}
              style={getRowStyle(row.cells?.length)}
            >
              {row.cells?.map((cell, i) => (
                <div
                  key={i}
                  className="sm18"
                  dangerouslySetInnerHTML={{ __html: cell }}
                />
              ))}
            </div>
          ))}
        </div>
        {disclaimer && <p className="table__disclaimer">{disclaimer}</p>}
      </div>
    </div>
  )
}
